import { clientIdentification } from '@gjensidige/service-client-identification';

class Setup {
  configure() {
    this.setClientIdentification();
  }

  private setClientIdentification() {
    clientIdentification.configure({
      clientId: 'calculation-widget-villa-home',
      clientVersion: '1.0.0'
    });
  }
}

export default new Setup();
